import { h, Component, Fragment } from 'preact'
import ProductsAPI from '../api/ProductsAPI'
import CategoriesAPI from '../api/CategoriesAPI'
import BrandsAPI from '../api/BrandsAPI'
import AnimalsAPI from '../api/AnimalsAPI'
import TableAPI from '../api/TableAPI'
import Posts from '../components/Posts'
import Filter from './Filter'
import OrderBy from '../components/Orderby'
import Loader from '../components/Loader'
import { clearAllBodyScrollLocks } from 'body-scroll-lock'

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class App extends Component {
  constructor(props) {
    super(props)

    this.state = {
      filterLabel: props.filterLabel,
      showMoreLabel: props.showMore,
      showLessLabel: props.showLess,
      suggestedLabel: props.suggestedLabel,
      itemsLabel: props.itemsLabel,
      addingLabel: props.addingLabel,
      readMoreLabel: props.readMoreLabel,
      labelAnimal: props.labelAnimal,
      labelCategory: props.labelCategory,
      labelBrand: props.labelBrand,
      uspOne: props.uspOne,
      uspTwo: props.uspTwo,
      uspThree: props.uspThree,
      isLoading: true,
      posts: [],
      allPosts: [],
      currentSlug: '',
      totalAmountProducts: null,
      categories: [],
      animals: [],
      brands: [],
      currentCategories: [],
      currentAnimals: [],
      currentBrands: [],
      startAnimal: props.startAnimal,
      startBrand: props.startBrand,
      startCategory: props.startCategory,
      suggestedAnimal: props.suggestedAnimal,
      suggestedBrand: props.suggestedBrand,
      suggestedCategory: props.suggestedCategory,
      currentLanguage: props.currentLanguage,
      count: 15,
      offset: 0,
      currentPage: 1,
      order: '',
      showAll: false,
      searchText: '',
      searchActive: false,
      filterMenu: false,
      resetUrlParam: false,
      loggedIn: props.loggedIn
    }
  }

  componentDidMount() {
    if (this.state.startAnimal) {
      const splitAnimal = this.state.startAnimal.split(';')
      this.setState({ currentAnimals: splitAnimal })
    }

    if (this.state.startBrand) {
      const splitBrand = this.state.startBrand.split(';')
      this.setState({ currentBrands: splitBrand })
    }

    if (this.state.startCategory) {
      const splitCategory = this.state.startCategory.split(';')
      this.setState({ currentCategories: splitCategory })
    }

    if (this.state.suggestedAnimal) {
      const splitAnimals = this.state.suggestedAnimal.split(';')
      this.setState({ suggestedAnimal: splitAnimals })
    }

    if (this.state.suggestedBrand) {
      const splitBrands = this.state.suggestedBrand.split(';')
      this.setState({ suggestedBrand: splitBrands })
    }

    if (this.state.suggestedCategory) {
      const splitCategories = this.state.suggestedCategory.split(';')
      this.setState({ suggestedCategory: splitCategories })
    }

    if (this.state.currentLanguage == 'en') {
      this.setState({ currentLanguage: '' })
    }

    if (!this.state.resetUrlParam) {
      this.fetchAnimalsFilterUrl()
      this.fetchCategoriesFilterUrl()
      this.fetchBrandsFilterUrl()
    }

    this.fetchCategoriesFilters()
      .then(() => {
        this.fetchAnimalsFilters()
          .then(() => {
            this.fetchBrandsFilters()
              .then(() => {
                this.initiate()
                this.fetchAllPosts()
              })
              .catch(error => {})
          })
          .catch(error => {})
      })
      .catch(error => {})
  }

  initiate() {
    this.fetchProducts()
  }

  fetchProducts() {
    this.setState({ isLoading: true })

    ProductsAPI.all(this.state)
      .then(response => {
        this.setState({
          totalAmountProducts: response.headers.get('x-wp-total')
        })
        return response.json()
      })
      .then(data => {
        this.setState({
          posts: [...this.state.posts, ...data],
          isLoading: false
        })
      })
      .catch(error => {
        this.setState({
          fetchError: true,
          isLoading: false
        })
        throw Error(`Fetching products failed: ${error}`)
      })
  }

  // Fetch Categories
  fetchCategoriesFilters() {
    return new Promise((resolve, reject) => {
      this.setState({ isLoading: true })

      CategoriesAPI.all(this.state)
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.setState(() => {
            return {
              categories: data,
              isLoading: false
            }
          }, this.setCurrentCategoryWithSlug)
          resolve()
        })
        .catch(error => {
          this.setState({
            fetchError: true,
            isLoading: false
          })
          reject()
          throw Error(`Fetching products failed: ${error}`)
        })
    })
  }

  fetchCategoriesFilterUrl() {
    const currentURL = window.location.href
    let splittedUrl = currentURL.split('/')
    const categoryOptions = [
      'product_category',
      'product-category',
      'vare-kategori',
      'categorie-produit',
      'produkt-kategorie',
      'categoria-prodotto',
      'product-categorie',
      'produktkategori',
      'produkt-kategori',
      'categoria-producto'
    ]

    categoryOptions.forEach(categoryOption => {
      if (currentURL.includes(categoryOption)) {
        let indexCategory = splittedUrl.indexOf(categoryOption)
        const indexCategoryElement = indexCategory + 1
        // const categoryElement = splittedUrl[indexCategoryElement]

        // Look at the last part of the URL
        const categoryElement =
          splittedUrl[splittedUrl.length - 1] !== ''
            ? splittedUrl[splittedUrl.length - 1]
            : splittedUrl[splittedUrl.length - 2]

        console.log('Setting category category slug')
        this.setState({ currentSlug: categoryElement })
      }
    })
  }

  setCurrentCategoryWithSlug() {
    if (this.state.currentSlug !== '' && !this.state.resetUrlParam) {
      console.log(this.state.currentSlug)
      let currentCategory = this.state.categories.filter(
        category => category.slug == this.state.currentSlug
      )
      currentCategory = currentCategory[0]
      let subCategoryIds = []
      let subSubCategoryIds = []

      if (currentCategory) {
        // Get all subcategories that have the current category as parent
        const currentSubCategories = this.state.categories.filter(
          cat => cat.parent === currentCategory.id
        )
        subCategoryIds = currentSubCategories.map(subcategory => subcategory.id)

        // Get all subsubcategories that have one of the current subcategories as parent
        const currentSubSubCategories = this.state.categories.filter(cat =>
          subCategoryIds.includes(cat.parent)
        )
        subSubCategoryIds = currentSubSubCategories.map(
          subsubcategory => subsubcategory.id
        )
      }

      if (currentCategory && this.state.filterMenu === false) {
        let currentCategories = [...this.state.currentCategories]
        if (!currentCategories.includes(currentCategory.id)) {
          currentCategories.push(currentCategory.id)
          currentCategories = currentCategories.concat(subCategoryIds)
          currentCategories = currentCategories.concat(subSubCategoryIds)

          this.setState(() => {
            return {
              currentCategories: currentCategories,
              // posts: [],
              offset: 0
            }
          })
        }
      }
    }
  }

  // Fetch Animals
  fetchAnimalsFilters() {
    return new Promise((resolve, reject) => {
      this.setState({ isLoading: true })

      AnimalsAPI.all(this.state)
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.setState(() => {
            return {
              animals: data,
              isLoading: false
            }
          }, this.setCurrentAnimalWithSlug)
          resolve()
        })
        .catch(error => {
          this.setState({
            fetchError: true,
            isLoading: false
          })
          reject()
          throw Error(`Fetching products failed: ${error}`)
        })
    })
  }

  fetchAnimalsFilterUrl() {
    const currentURL = window.location.href
    let splittedUrl = currentURL.split('/')
    const animalCategoryOptions = ['animal_category', 'dyr', 'djur']

    animalCategoryOptions.forEach(animalCategoryOption => {
      if (currentURL.includes(animalCategoryOption)) {
        let indexCategory = splittedUrl.indexOf(animalCategoryOption)
        const indexCategoryElement = indexCategory + 1
        const categoryElement = splittedUrl[indexCategoryElement]
        console.log('Setting animal category slug')
        this.setState({ currentSlug: categoryElement })
      }
    })
  }

  setCurrentAnimalWithSlug() {
    if (this.state.currentSlug !== '' && !this.state.resetUrlParam) {
      let currentAnimal = this.state.animals.filter(
        animal => animal.slug == this.state.currentSlug
      )
      currentAnimal = currentAnimal[0]

      if (currentAnimal && this.state.filterMenu == false) {
        const currentAnimals = [...this.state.currentAnimals]
        if (!currentAnimals.includes(currentAnimal.id)) {
          currentAnimals.push(currentAnimal.id)

          this.setState(() => {
            return {
              currentAnimals: currentAnimals,
              offset: 0
            }
          })
        }
      }
    }
  }

  // Fetch Brands
  fetchBrandsFilters() {
    return new Promise((resolve, reject) => {
      this.setState({ isLoading: true })

      BrandsAPI.all(this.state)
        .then(response => {
          return response.json()
        })
        .then(data => {
          this.setState(() => {
            return {
              brands: data,
              isLoading: false
            }
          }, this.setCurrentBrandWithSlug)
          resolve()
        })
        .catch(error => {
          this.setState({
            fetchError: true,
            isLoading: false
          })
          reject()
          throw Error(`Fetching products failed: ${error}`)
        })
    })
  }

  fetchBrandsFilterUrl() {
    const currentURL = window.location.href
    let splittedUrl = currentURL.split('/')
    const categoryOptions = [
      'product_category',
      'vare-kategori',
      'categorie-produit',
      'produkt-kategorie',
      'categoria-prodotto',
      'product-categorie',
      'produktkategori',
      'produkt-kategori',
      'categoria-producto'
    ]

    categoryOptions.forEach(categoryOption => {
      if (currentURL.includes(categoryOption)) {
        let indexCategory = splittedUrl.indexOf(categoryOption)
        const indexCategoryElement = indexCategory + 1
        // const categoryElement = splittedUrl[indexCategoryElement]

        // Look at the last part of the URL
        const categoryElement =
          splittedUrl[splittedUrl.length - 1] !== ''
            ? splittedUrl[splittedUrl.length - 1]
            : splittedUrl[splittedUrl.length - 2]
        console.log('Setting brand category slug')
        this.setState({ currentSlug: categoryElement })
      }
    })
  }

  setCurrentBrandWithSlug() {
    if (this.state.currentSlug !== '' && !this.state.resetUrlParam) {
      let currentBrand = this.state.brands.filter(
        category => category.slug == this.state.currentSlug
      )
      currentBrand = currentBrand[0]

      if (currentBrand && this.state.filterMenu == false) {
        const currentBrands = [...this.state.currentBrands]
        if (!currentBrands.includes(currentBrand.id)) {
          currentBrands.push(currentBrand.id)

          this.setState(() => {
            return {
              currentBrands: currentBrands,
              offset: 0
            }
          })
        }
      }
    }
  }

  fetchAllPosts() {
    this.setState({ isLoading: true })

    TableAPI.all(this.state)
      .then(response => {
        return response.json()
      })
      .then(data => {
        this.setState({
          allPosts: [...this.state.allPosts, ...data],
          isLoading: false
        })
      })
      .catch(error => {
        this.setState({
          fetchError: true,
          isLoading: false
        })
        throw Error(`Fetching products failed: ${error}`)
      })
  }

  // Add or remove filters from state
  handleChange(e) {
    let currentElements = [...this.state[e.currentTarget.dataset.target]]
    const targetID = e.currentTarget.dataset.id * 1

    if (currentElements.includes(targetID)) {
      currentElements = currentElements.filter(item => item !== targetID)
    } else {
      currentElements.push(targetID)
    }

    // this.updateURLWithFilter(e.currentTarget.dataset.target, e.currentTarget.id); // Addon for later update

    this.setState(() => {
      return {
        [e.currentTarget.dataset.target]: currentElements,
        posts: [],
        // allPosts: [],
        offset: 0
      }
    }, this.initiate)
  }

  // Add selected filter to param
  updateURLWithFilter(target, name) {
    const animalsArray = [
      { id: '', title: 'animal' },
      { id: 'at', title: 'tier' },
      { id: 'be', title: 'dier' },
      { id: 'da', title: 'dyr' },
      { id: 'fi', title: 'elain' },
      { id: 'fr', title: 'animal' },
      { id: 'fr-be', title: 'animal' },
      { id: 'de', title: 'tier' },
      { id: 'ga', title: 'animal' },
      { id: 'it', title: 'animale' },
      { id: 'lu', title: 'typ' },
      { id: 'nl', title: 'dier' },
      { id: 'no', title: 'dyr' },
      { id: 'pl', title: 'zwierze' },
      { id: 'pt-pt', title: 'animal' },
      { id: 'es', title: 'animal' },
      { id: 'sv', title: 'djur' },
      { id: 'ch', title: 'tierart' },
      { id: 'uk', title: 'animal' },
      { id: 'gb', title: 'animal' },
      { id: 'us', title: 'animal' }
    ]
    const categoriesArray = [
      { id: '', title: 'category' },
      { id: 'at', title: 'kategorie' },
      { id: 'be', title: 'categorie' },
      { id: 'da', title: 'kategori' },
      { id: 'fi', title: 'kategoria' },
      { id: 'fr', title: 'categorie' },
      { id: 'fr-be', title: 'categorie' },
      { id: 'de', title: 'kategorie' },
      { id: 'ga', title: 'category' },
      { id: 'it', title: 'categoria' },
      { id: 'lu', title: 'kategorie' },
      { id: 'nl', title: 'categorie' },
      { id: 'no', title: 'kategori' },
      { id: 'pl', title: 'kategoria' },
      { id: 'pt-pt', title: 'categoria' },
      { id: 'es', title: 'categoria' },
      { id: 'sv', title: 'kategori' },
      { id: 'ch', title: 'kategorie' },
      { id: 'uk', title: 'category' },
      { id: 'gb', title: 'category' },
      { id: 'us', title: 'category' }
    ]
    const brandsArray = [
      { id: '', title: 'brand' },
      { id: 'at', title: 'marke' },
      { id: 'be', title: 'merk' },
      { id: 'da', title: 'maerke' },
      { id: 'fi', title: 'brandi' },
      { id: 'fr', title: 'marque' },
      { id: 'fr-be', title: 'marque' },
      { id: 'de', title: 'marke' },
      { id: 'ga', title: 'brand' },
      { id: 'it', title: 'marca' },
      { id: 'lu', title: 'mark' },
      { id: 'nl', title: 'merk' },
      { id: 'no', title: 'merke' },
      { id: 'pl', title: 'marka' },
      { id: 'pt-pt', title: 'marka' },
      { id: 'es', title: 'marca' },
      { id: 'sv', title: 'varumarke' },
      { id: 'ch', title: 'marke' },
      { id: 'uk', title: 'brand' },
      { id: 'gb', title: 'brand' },
      { id: 'us', title: 'brand' }
    ]

    if (target == 'currentAnimals') {
      const urlParam = animalsArray.find(
        ({ id }) => id === this.state.currentLanguage
      ).title
      if (history.pushState) this.paramToURL(urlParam, name)
    }

    if (target == 'currentCategories') {
      const urlParam = categoriesArray.find(
        ({ id }) => id === this.state.currentLanguage
      ).title
      if (history.pushState) this.paramToURL(urlParam, name)
    }

    if (target == 'currentBrands') {
      const urlParam = brandsArray.find(
        ({ id }) => id === this.state.currentLanguage
      ).title
      if (history.pushState) this.paramToURL(urlParam, name)
    }
  }

  // Add filter param to url
  paramToURL(param, name) {
    const queryString = window.location.search
    const urlParams = new URLSearchParams(queryString)
    urlParams.set(param, name)
    let params = ''

    // Add second param to url if it already exists
    if (queryString.includes(param)) {
      const stringToArray = queryString.replace('?', '').split('&')
      stringToArray.push(param + '=' + name)
      params = stringToArray.join('&').toString()
    } else {
      params = urlParams.toString()
    }

    // Remove specified param from url
    if (queryString.includes(name)) {
      const convertCurrentParams = queryString.replace('?', '').split('&')

      ;[...convertCurrentParams].forEach(item => {
        if (item.includes(param + '=' + name))
          convertCurrentParams.splice(convertCurrentParams.indexOf(item), 1)
      })

      params = convertCurrentParams.join('&').toString()
    }

    let newUrl =
      window.location.protocol +
      '//' +
      window.location.host +
      window.location.pathname +
      '?' +
      params
    window.history.pushState({ path: newUrl }, '', newUrl)
  }

  // Add suggested filters to state
  handleSuggested(e) {
    let currentElements = [...this.state[e.currentTarget.dataset.target]]
    const targetID = e.currentTarget.dataset.id * 1

    if (currentElements.includes(targetID)) {
      currentElements = currentElements.filter(item => item !== targetID)
    } else {
      currentElements.push(targetID)
    }

    this.setState(() => {
      return {
        [e.currentTarget.dataset.target]: currentElements,
        posts: [],
        // allPosts: [],
        offset: 0
      }
    }, this.initiate)
  }

  // Remove filter from state
  handleRemove(e) {
    let currentElements = [...this.state[e.currentTarget.dataset.target]]
    const targetID = e.currentTarget.dataset.id * 1
    currentElements = currentElements.filter(item => item !== targetID)

    this.setState(() => {
      return {
        [e.currentTarget.dataset.target]: currentElements,
        posts: [],
        // allPosts: [],
        offset: 0,
        currentSlug: '',
        filterMenu: true,
        resetUrlParam: true
      }
    }, this.initiate)
  }

  handleRemoveSearch(e) {
    this.setState(() => {
      return {
        searchText: '',
        posts: [],
        // allPosts: [],
        offset: 0,
        currentSlug: '',
        filterMenu: true,
        resetUrlParam: true
      }
    }, this.initiate)
  }

  handleReset(e) {
    this.setState(() => {
      return {
        searchText: '',
        posts: [],
        // allPosts: [],
        offset: 0,
        currentSlug: '',
        filterMenu: true,
        resetUrlParam: true,
        currentCategories: [],
        currentAnimals: [],
        currentBrands: []
      }
    }, this.initiate)
  }

  handleClick(e) {
    // Add start filters to the state
    const splitAnimal = this.state.startAnimal
      ? this.state.startAnimal.split(';')
      : []
    const splitBrand = this.state.startBrand
      ? this.state.startBrand.split(';')
      : []
    const splitCategory = this.state.startCategory
      ? this.state.startCategory.split(';')
      : []

    // remove added params
    if (history.pushState) {
      const queryString = window.location.search
      const urlParams = new URLSearchParams(queryString)

      if (urlParams.size > 0) {
        let newUrl =
          window.location.protocol +
          '//' +
          window.location.host +
          window.location.pathname
        window.history.pushState({ path: newUrl }, '', newUrl)
      }
    }

    this.setState(() => {
      return {
        currentCategories: splitCategory,
        currentAnimals: splitAnimal,
        currentBrands: splitBrand,
        // searchText: '',
        posts: [],
        // allPosts: [],
        offset: 0,
        resetUrlParam: true
      }
    }, this.initiate)
  }

  handleToggle() {
    if (this.state.filterActive) {
      clearAllBodyScrollLocks()
    }
    this.setState({ filterActive: !this.state.filterActive })
  }

  handleOrderChoice(order) {
    this.setState(
      {
        order: order,
        posts: [],
        // allPosts: [],
        offset: 0
      },
      this.initiate
    )
  }

  handleShowMore(e) {
    this.setState(prevState => {
      return {
        offset: prevState.offset + this.state.count,
        count: this.state.count + this.state.count
      }
    }, this.fetchProducts)
  }

  handleSearch(searchText) {
    this.setState({
      searchText: searchText
    })
  }

  handleSearchSubmit() {
    this.setState(
      {
        posts: []
        // allPosts: []
      },
      this.initiate
    )
  }

  render() {
    return (
      <div className="c-shop-overview__app-container">
        <div className="c-shop-overview__filter-top-bar u-flex u-flex-sb">
          <div
            className="c-shop-overview__filter-button"
            onClick={this.handleToggle.bind(this)}
          >
            {this.state.filterActive ? (
              <svg className="c-icon c-shop-overview__filter-icon active">
                <use href="#close" xlinkHref="#close" />
              </svg>
            ) : (
              <svg className="c-icon c-shop-overview__filter-icon">
                <use href="#filter" xlinkHref="#filter" />
              </svg>
            )}
            Filter
          </div>

          <div className="c-shop-overview__filter-button">
            <OrderBy
              order={this.state.order}
              onSelectOrder={this.handleOrderChoice.bind(this)}
              postsLoading={this.state.isLoading}
              language={this.state.currentLanguage}
            />
          </div>
        </div>
        <div class="c-shop-overview__filter-container">
          <Filter
            posts={this.state.posts}
            allPosts={this.state.allPosts}
            categories={this.state.categories}
            animals={this.state.animals}
            brands={this.state.brands}
            labelAnimal={this.state.labelAnimal}
            labelCategory={this.state.labelCategory}
            labelBrand={this.state.labelBrand}
            startAnimal={this.state.startAnimal}
            startBrand={this.state.startBrand}
            startCategory={this.state.startCategory}
            currentCategories={this.state.currentCategories}
            currentAnimals={this.state.currentAnimals}
            currentBrands={this.state.currentBrands}
            handleChange={this.handleChange.bind(this)}
            handleClick={this.handleClick.bind(this)}
            filterActive={this.state.filterActive}
            handleToggle={this.handleToggle.bind(this)}
            isLoading={this.state.isLoading}
            placeholder={this.state.filterLabel}
            filterLabel={this.state.filterLabel}
            showMoreLabel={this.state.showMoreLabel}
            showLessLabel={this.state.showLessLabel}
            handleRemove={this.handleRemove.bind(this)}
            handleRemoveSearch={this.handleRemoveSearch.bind(this)}
            handleReset={this.handleReset.bind(this)}
            searchText={this.state.searchText}
            language={this.state.currentLanguage}
          />
        </div>
        <div class="c-shop-overview__posts-wrapper">
          {this.state.posts.length > 0 ? (
            <div class="c-shop-overview__posts-container">
              <Posts
                posts={this.state.posts}
                offset={this.state.offset}
                itemsLabel={this.state.itemsLabel}
                addLabel={this.state.addingLabel}
                readMoreLabel={this.state.readMoreLabel}
                suggestedLabel={this.state.suggestedLabel}
                loading={this.state.isLoading}
                nrAll={this.state.totalAmountProducts}
                count={this.state.count}
                uspOne={this.state.uspOne}
                uspTwo={this.state.uspTwo}
                uspThree={this.state.uspThree}
                suggestedAnimal={this.state.suggestedAnimal}
                suggestedBrand={this.state.suggestedBrand}
                suggestedCategory={this.state.suggestedCategory}
                categories={this.state.categories}
                animals={this.state.animals}
                brands={this.state.brands}
                handleSuggested={this.handleSuggested.bind(this)}
                order={this.state.order}
                handleOrderChoice={this.handleOrderChoice.bind(this)}
                currentLanguage={this.state.currentLanguage}
                handleShowMore={this.handleShowMore.bind(this)}
                searchText={this.state.filterLabel}
                onSearch={this.handleSearch.bind(this)}
                onSubmit={this.handleSearchSubmit.bind(this)}
                loggedIn={this.state.loggedIn}
              />
            </div>
          ) : (
            <Fragment>
              {this.state.isLoading ? (
                <Loader />
              ) : (
                <div className="c-shop-overview__no-posts">
                  No results
                  <div
                    className="c-shop-overview__reset"
                    onClick={() => {
                      this.handleClick()
                    }}
                  >
                    Reset filters
                  </div>
                </div>
              )}
            </Fragment>
          )}
        </div>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/js/shop/containers/App.js